(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["recommended-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('recommended-products-carousel')) {
    customElements.define(
      'recommended-products-carousel',
      class RecommendedProductsCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.currentIndex = 0;

          this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
          this.querySelectorAll('.recommended-products__form').forEach((form) => {
            form.addEventListener('submit', (event) => this.addToCart(event));
          });
        }

        async addToCart(event) {
          event.preventDefault();

          const form = event.currentTarget;
          const button = form.querySelector('.recommended-products__add-to-cart');
          if (!button || button.dataset.loading === 'true') return;

          const addLabel = button.querySelector('[data-add-label]');
          const addedLabel = button.querySelector('[data-added-label]');
          button.dataset.loading = 'true';
          button.disabled = true;

          try {
            const addedItem = await this.submitCartForm(form);
            const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              headers: { Accept: 'application/json' },
            }).then((response) => {
              if (!response.ok) throw new Error('Unable to refresh cart');
              return response.json();
            });

            this.updateCartCount(cart.item_count);
            this.openCartDrawer(addedItem, cart.item_count);
            addLabel.hidden = true;
            addedLabel.hidden = false;
            button.classList.add('is-added');

            window.setTimeout(() => {
              addLabel.hidden = false;
              addedLabel.hidden = true;
              button.classList.remove('is-added');
              button.disabled = false;
              delete button.dataset.loading;
            }, 1800);
          } catch (error) {
            button.disabled = false;
            delete button.dataset.loading;
          }
        }

        submitCartForm(form) {
          return new Promise((resolve, reject) => {
            const formData = new FormData(form);
            const cartDrawer = document.querySelector('cart-drawer#cart-drawer, cart-drawer');
            const sectionIds =
              typeof cartDrawer?.getSectionsToRender === 'function'
                ? cartDrawer.getSectionsToRender().map((section) => section.id)
                : ['cart-drawer', 'cart-icon-bubble'];

            formData.append('sections', sectionIds.join(','));
            formData.append('sections_url', window.location.pathname);

            const request = new XMLHttpRequest();
            request.open('POST', form.action, true);
            request.setRequestHeader('Accept', 'application/json');
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            request.onload = () => {
              if (request.status >= 200 && request.status < 300) {
                try {
                  resolve(JSON.parse(request.responseText));
                } catch (error) {
                  reject(error);
                }
              } else {
                reject(new Error('Unable to add item'));
              }
            };
            request.onerror = () => reject(new Error('Unable to add item'));
            request.send(formData);
          });
        }

        openCartDrawer(addedItem, itemCount) {
          const cartDrawer = document.querySelector('cart-drawer#cart-drawer, cart-drawer');
          if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !addedItem.sections) return;

          try {
            cartDrawer.renderContents({ ...addedItem, item_count: itemCount });
          } catch (error) {
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
          }
        }

        updateCartCount(itemCount) {
          document
            .querySelectorAll('cart-count, [data-cart-count], .cart-count-bubble, .cart-bubble__text')
            .forEach((count) => {
            count.textContent = itemCount;
            count.classList.toggle('opacity-0', itemCount === 0);
            if (count.hasAttribute('data-cart-count')) count.setAttribute('data-cart-count', itemCount);
          });

          document.querySelectorAll('.cart-bubble__background').forEach((background) => {
            const bubble = background.closest('.cart-bubble') || background.parentElement;
            if (!bubble) return;

            bubble.hidden = itemCount === 0;
            bubble.setAttribute('aria-hidden', itemCount === 0 ? 'true' : 'false');
            bubble.classList.toggle('hidden', itemCount === 0);
            bubble.classList.toggle('visually-hidden', itemCount === 0);
            bubble.classList.toggle('opacity-0', itemCount === 0);
          });
        }

        show(index) {
          if (this.slides.length < 2) return;

          this.currentIndex = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.currentIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === this.currentIndex));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
